import React from "react";
import { useQuestionnaire } from "./QuestionnaireContext";
export default function QuestionnaireDetails() {
  const { state, dispatch } = useQuestionnaire();
  const { meta } = state;


  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch({
      type: "UPDATE_META",
      payload: { [name]: value },
    });
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-sm border border-gray-200 mt-6">
      <h2 className="text-xl font-semibold mb-4 text-gray-800">
        Basic Information
      </h2>
      
      <div className="space-y-4">
        {/* Questionnaire Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Questionnaire Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={meta.name || ""}
            onChange={handleChange}
            placeholder="e.g., Weekly Safety Check - Cycle 1"
            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        {/* Description / Purpose */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Description / Purpose
          </label>
          <textarea
            name="purpose" 
            value={meta.purpose || ""}
            onChange={handleChange}
            rows={4}
            placeholder="Describe the goal of this form (e.g., monitor patient temperature and vitals)."
            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        {/* Status (Optional - if you want to set it here) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Status
          </label>
          <select
            name="status"
            value={meta.status || "Draft"}
            onChange={handleChange}
            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:outline-none bg-white"
          >
            <option value="Draft">Draft</option>
            <option value="Published">Published</option>
            <option value="Archived">Archived</option>
          </select>
        </div>
      </div>
      
      <div className="mt-6 p-4 bg-blue-50 text-blue-700 text-sm rounded border border-blue-100">
        <strong>Tip:</strong> Give your questionnaire a clear name so it's easily identifiable in the enrollment screen later.
      </div>
    </div>
  );
}